/**
 * Valida CNPJ pelo algoritmo dos dígitos verificadores (Receita Federal).
 * Rejeita sequências inválidas (todos dígitos iguais) e verifica os dois dígitos verificadores.
 * @param {string} cnpj - CNPJ com ou sem formatação
 * @returns {boolean}
 */
export function isValidCnpj(cnpj) {
	const clean = String(cnpj).replace(/\D/g, "");
	if (clean.length !== 14) return false;

	if (/^(\d)\1{13}$/.test(clean)) return false;

	const weights1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
	const weights2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

	let sum = 0;
	for (let i = 0; i < 12; i++) {
		sum += parseInt(clean[i], 10) * weights1[i];
	}
	let rest = sum % 11;
	const digit1 = rest < 2 ? 0 : 11 - rest;
	if (digit1 !== parseInt(clean[12], 10)) return false;

	sum = 0;
	for (let i = 0; i < 13; i++) {
		sum += parseInt(clean[i], 10) * weights2[i];
	}
	rest = sum % 11;
	const digit2 = rest < 2 ? 0 : 11 - rest;
	if (digit2 !== parseInt(clean[13], 10)) return false;

	return true;
}
